// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../node_modules/postcss-loader/dist/cjs.js!../style/theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.labelGroup_AtKYn {
  display: flex;
  flex-direction: row;
  /*margin: 10px 10px;*/
  align-items: center;
  position:relative;
}

.labelGroup_AtKYn.vertical_npLKx {
  display: flex;
  flex-direction: column;
  align-items: flex-start;

}

.labelGroup_AtKYn > * {
  flex:1 0 auto;
}
.labelGroup_AtKYn > label { 
  /*font-family: Lato, helevetica, sans-serif;*/
  font-size:12px;
  font-weight: normal;
  margin : 0 10px 0 0;
  flex:0 0 auto;
  min-width: var(--label-size);
  text-align: right;
}
.labelGroup_AtKYn.vertical_npLKx > label { 
  margin : 0 0 5px 0;
}
`, "",{"version":3,"sources":["webpack://./src/views/LabelGroup.css"],"names":[],"mappings":"AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;;AAEzB;;AAEA;EACE,aAAa;AACf;AACA;EACE,6CAA6C;EAC7C,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,4BAA4B;EAC5B,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB","sourcesContent":["@import \"../style/theme.css\";\n\n\n.labelGroup {\n  display: flex;\n  flex-direction: row;\n  /*margin: 10px 10px;*/\n  align-items: center;\n  position:relative;\n}\n\n.labelGroup.vertical {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n\n}\n\n.labelGroup > * {\n  flex:1 0 auto;\n}\n.labelGroup > label { \n  /*font-family: Lato, helevetica, sans-serif;*/\n  font-size:12px;\n  font-weight: normal;\n  margin : 0 10px 0 0;\n  flex:0 0 auto;\n  min-width: var(--label-size);\n  text-align: right;\n}\n.labelGroup.vertical > label { \n  margin : 0 0 5px 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"labelGroup": `labelGroup_AtKYn`,
	"vertical": `vertical_npLKx`
};
export default ___CSS_LOADER_EXPORT___;
